import { useEffect, useRef } from "react";

const getFocusable = (container) => {
  if (!container) return [];
  return Array.from(
    container.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    )
  );
};

export default function useModalBehavior(isOpen, onClose, containerRef) {
  const lastActiveRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    lastActiveRef.current = document.activeElement;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
        return;
      }

      if (event.key !== "Tab") return;
      const focusable = getFocusable(containerRef?.current);
      if (focusable.length === 0) {
        event.preventDefault();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const isShift = event.shiftKey;
      if (isShift && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!isShift && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [containerRef, isOpen, onClose]);

  useEffect(() => {
    if (!isOpen && lastActiveRef.current) {
      lastActiveRef.current.focus();
    }
  }, [isOpen]);
}
